import React from "react";
import ContactForm from "../ContactFrom/ContactForm";
import icon2 from "../../images/icon/icon-sms.svg";

const ContactSection = () => {
  return (
    <div className="contact pt-85">
      <div className="container">
        <div className="row pb-130 mt-none-30">

          {/* LEFT — CONTACT FORM */}
          <div className="col-lg-8 mt-30">
            <div className="cs-contact-wrap cs-contact-form cd-contact-form item-contact_form">
              <h2 className="xb-title">Send us a message</h2>
              <p className="xb-content">
                Reach out to us for delegate registrations, sponsorship
                opportunities, speaker enquiries, or general conference
                information. Our team will get back to you as soon as possible.
              </p>

              <ContactForm />
            </div>
          </div>

          {/* RIGHT — CONTACT INFO */}
          <div className="col-lg-4 mt-30">
            <div className="item-contact_info">
              <div className="xb-item--inner">
                <div className="xb-item--top">
                  <h3 className="xb-item--title">Contact Information</h3>

                  <span className="xb-item--email">
                    <img src={icon2} alt="" />
                    info@aroevents.com
                  </span>

                  <p style={{ marginTop: "16px", fontSize: "15px", lineHeight: "1.6" }}>
                    We accept enquiries at any time.
                    Whether you're a delegate, sponsor, or speaker —
                    feel free to message us anytime.
                  </p>

                  {/* SOCIAL LINKS */}
                  <ul className="social_icons_block list-unstyled ul_li mt-20">
                    {/* LinkedIn */}
                    <li>
                      <a
                        href="https://www.linkedin.com/company/aro-events/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>

                    {/* Instagram */}
                    <li>
                      <a
                        href="https://www.instagram.com/aro_events_?igsh=c2N5Z2diazZxN29y&utm_source=qr"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>

                    {/* Facebook */}
                    <li>
                      <a
                        href="https://www.facebook.com/share/16jvYa6rF7/?mibextid=wwXIfr"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                      >
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>

                    {/* X (Twitter) — SVG */}
                    <li>
                      <a
                        href="https://x.com/AroEvents"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="X"
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M18.244 2H21.552L14.308 10.29L22.856 22H16.03L10.684 14.513L4.736 22H1.424L9.17 13.13L1 2H8.03L12.87 8.606L18.244 2ZM16.92 19.82H18.753L7.09 4.067H5.124L16.92 19.82Z"/>
                        </svg>
                      </a>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactSection;
